import * as React from "react";
import { placeFeatures } from "#stores/place";
import { useGetPlaceFeatures } from "./integrations/place/query";
import { browserHistory } from "react-router";
import { showErrorNotification } from "../helpers/notifications";
import { useTranslation } from "react-i18next";

export function useHasPlaceFeature({
	placeId,
	featureId,
	redirectTo,
}: {
	placeId: string;
	featureId: placeFeatures;
	redirectTo?: string;
}): [hasPlaceFeature: boolean, isLoading: boolean] {
	const { t: tGlobal } = useTranslation("globalKeys");
	const { data: placeFeatures, isLoading } = useGetPlaceFeatures(
		{ placeId },
		{
			enabled: !!placeId,
		},
	);
	const hasPlaceFeature = React.useMemo(() => {
		return !!placeFeatures?.some(
			placeFeature => placeFeature.id === featureId && placeFeature.isActive,
		);
	}, [placeId, featureId, placeFeatures]);

	React.useEffect(() => {
		if (redirectTo && !isLoading && !hasPlaceFeature) {
			showErrorNotification(tGlobal($ => $.withoutPermissionToViewPage));
			browserHistory.push(redirectTo);
		}
	}, [hasPlaceFeature, isLoading, redirectTo]);

	return [hasPlaceFeature, isLoading];
}
